"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabelText = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    color: ", ";\n    display: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var label1 = 'label1';
var placeholder1 = 'placeholder1';
var error = 'error';
var assistive = 'assistive';
var notification = 'notification';

var getFontStyle = function getFontStyle(props, type) {
  var label = (0, _versions.getTypography)(props, 'label');
  var font = (0, _get2["default"])(label, type, {});
  var color;

  if (props.color === 'inherit' || props.color === 'initial') {
    color = props.color;
  } else {
    color = props.color && _tokens.baseColors[props.color] || font.color;
  }

  return (0, _styledComponents.css)(_templateObject(), font.fontFamily, font.fontSize, font.lineHeight, font.letterSpacing, color, props.block ? 'block' : 'inline-block');
};

var BaseStyledLabelText = _styledComponents["default"].span(_templateObject2());

var StyledLabelText = {};
exports.StyledLabelText = StyledLabelText;
StyledLabelText[label1] = BaseStyledLabelText.extend(_templateObject3(), function (props) {
  return getFontStyle(props, label1);
});
StyledLabelText[placeholder1] = BaseStyledLabelText.extend(_templateObject4(), function (props) {
  return getFontStyle(props, placeholder1);
});
StyledLabelText[error] = BaseStyledLabelText.extend(_templateObject5(), function (props) {
  return getFontStyle(props, error);
});
StyledLabelText[assistive] = BaseStyledLabelText.extend(_templateObject6(), function (props) {
  return getFontStyle(props, assistive);
});
StyledLabelText[notification] = BaseStyledLabelText.extend(_templateObject7(), function (props) {
  return getFontStyle(props, notification);
});

var Label = function Label(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var Component = StyledLabelText[props.type] || StyledLabelText[label1];
  return _react["default"].createElement(Component, props, children);
};

Label.propTypes = {
  type: _propTypes["default"].oneOf([label1, placeholder1, error, assistive, notification]),
  color: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
  block: _propTypes["default"].bool
};
Label.defaultProps = {
  type: label1,
  children: null,
  block: true
};
Label.displayName = 'Label';

var _default = (0, _context.withVersion)(Label);

exports["default"] = _default;